<template>
  <div class="lv-state-ques-option">
    <LvTextCard class="pa-16">
      <template v-slot:content>
        <LvFlexBox noWrap class="mb-8">
          <StateInputButton
            :value="title"
            required
            rules="required"
            placeholder="名稱"
            class="lv-state-ques-option__title-input"
            @input="$_onInput($event, 'title')"
          />
          <LvText v-if="isDeletable" h3 red @click="$emit('delete')"><i class="icon-delete"/></LvText>
        </LvFlexBox>
        <div class="lv-state-ques-option__section">
          <DropdownMenuButton
            v-if="!hasSubOption"
            :value="risk"
            outline
            placeholder="風險等級"
            :dropdownMenuItem="riskItems"
            class="lv-state-ques-option__section__item"
            @input="$_onInput($event, 'risk')"
          />
          <!-- <StateInputButton
            v-if="!hasSubOption"
            :value="score"
            type="number"
            widthIsPlaceholder
            placeholder="得分設定 (輸入數字)"
            class="lv-state-ques-option__section__item"
            @input="$_onInput($event, 'score')"
          /> -->
          <div class="lv-state-ques-option__checkbox">
            <LvCheckbox
              v-if="!hasSubOption"
              h4
              exclusive
              text="選答時要求必填備註"
              justifyContent="start"
              :value="true"
              :select="requiredRemark"
              class="lv-state-ques-option__section__item"
              @change="$_onInput($event, 'requiredRemark')"
            />
          </div>
          <div class="lv-state-ques-option__checkbox">
            <LvCheckbox
              h4
              exclusive
              text="開啟次級選項"
              justifyContent="start"
              :value="true"
              :select="hasSubOption"
              class="lv-state-ques-option__section__item"
              @change="$_onInput($event, 'hasSubOption')"
            />
          </div>
        </div>
      </template>
    </LvTextCard>
    <div
      v-if="hasSubOption && subOptionList && subOptionList.length"
      class="lv-state-ques-option__subOption-wrap"
    >
      <LvTextCard
        v-for="(subOption, subOptionIndex) in subOptionList"
        :key="subOptionIndex"
        class="lv-state-ques-option__subOption"
      >
        <template v-slot:content>
          <LvFlexBox noWrap class="mb-8">
            <StateInputButton
              :value="subOption.title"
              required
              rules="required"
              placeholder="名稱"
              class="mr-8 lv-state-ques-option__title-input"
              @input="$_onInput($event, 'title', subOptionIndex)"
            />
            <LvText h3 red @click="$emit('delete', {subOptionIndex})"><i class="icon-delete"/></LvText>
          </LvFlexBox>
          <div class="lv-state-ques-option__section">
            <DropdownMenuButton
              :value="subOption.risk"
              outline
              placeholder="風險等級"
              :dropdownMenuItem="riskItems"
              class="lv-state-ques-option__section__item"
              @input="$_onInput($event, 'risk', subOptionIndex)"
            />
            <!-- <StateInputButton
              :value="subOption.score"
              type="number"
              widthIsPlaceholder
              placeholder="得分設定 (輸入數字)"
              class="lv-state-ques-option__section__item"
              @input="$_onInput($event, 'score', subOptionIndex)"
            /> -->
            <div class="lv-state-ques-option__checkbox">
              <LvCheckbox
                h4
                exclusive
                text="選答時要求必填備註"
                justifyContent="start"
                :value="true"
                :select="subOption.requiredRemark"
                class="lv-state-ques-option__section__item"
                @change="$_onInput($event, 'requiredRemark', subOptionIndex)"
              />
            </div>
          </div>
        </template>
      </LvTextCard>
    </div>
    <WsTextButton001
      v-if="hasSubOption"
      small
      primary
      noPadding
      leadingIcon="icon-bih-add-circle"
      class="lv-state-ques-option__add"
      @click="$emit('add')"
    >{{ $t('新增次級選項') }}</WsTextButton001>
  </div>
</template>

<script>
import Spare_checklist from '@/spare/checklist';

export default {
  props: {
    title: {
      type: String,
    },
    score: {
      type: String,
    },
    requiredRemark: {},
    hasSubOption: {},
    risk: {},
    subOptionList: {
      type: Array,
    },
    isDeletable: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      riskItems: Spare_checklist.riskItems,
    }
  },
  computed: {
    _riskLevel() {
      return this.$store.state.model.checklistRiskLevelList.map(item => {
        return {text:item.text, subtext: item.subtext, type: item.type, score: item.score};
      });
    }
  },
  methods: {
    $_onInput($event, type, subOptionIndex) {
      this.$emit('input', {type, value: $event, subOptionIndex});
    },
  }
}
</script>